import React, { useMemo } from 'react';
import PaginationTable, {
    PaginationTableProps,
} from '../../../../../ui/DataDisplay/Tables/PaginationTable/PaginationTable';
import { SongSimple } from '@round/api';
import { Column } from 'react-table';
import Skeleton from '../../../../../ui/Skeleton/Skeleton';
import Image from '../../../../../ui/Image/Image';
import styles from './SongAdminTable.module.css';

type SongAdminTableProps = Omit<PaginationTableProps<SongSimple>, 'columns'>;

const SongAdminTable = (props: SongAdminTableProps) => {
    const columns: Column<SongSimple>[] = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'title',
                Cell: ({ value, row: { original } }) => (
                    <div className={styles.titleContainer}>
                        <Image
                            className={styles.image}
                            src={original.image ?? ''}
                            loading={props.loading}
                            alt={value}
                        />
                        <span>{props.loading ? <Skeleton width="7rem" /> : value}</span>
                    </div>
                ),
            },
            {
                Header: 'Artist Name',
                accessor: 'artists',
                Cell: ({ value }) => {
                    if (props.loading) {
                        return <Skeleton />;
                    }

                    return <>{value.map((a) => a.name).join(', ')}</>;
                },
            },
        ],
        [props.loading]
    );

    return <PaginationTable columns={columns} {...props} />;
};

export default SongAdminTable;
